// extracted by mini-css-extract-plugin
module.exports = {"card":"CraneDetails_card__1vyqN","table":"CraneDetails_table__1DAQ6","title":"CraneDetails_title__1i26k","wrapper":"CraneDetails_wrapper__2khmV"};